import { TFunction } from 'i18next'

export const sendFrequencyOptions = (t: TFunction) => [
    { label: t('send_frequency.weekly'), value: 'weekly' },
    { label: t('send_frequency.monthly'), value: 'monthly' },
]

export const sendFormatOptions = (t: TFunction) => [
    {
        label: t('send_format.default'),
        value: 'default',
    },
    {
        label: t('send_format.detailoriented'),
        value: 'DetailOriented',
    },
]

export const statusOptions = (t: TFunction) => [
    { label: t('status.activate'), value: 'activate' },
    { label: t('status.deactivate'), value: 'deactivate' },
]

export const domainSourceOptions = (t: TFunction) => [
    {
        label: t('domain_source.elastic'),
        value: 'elastic',
    },
    {
        label: t('domain_source.history'),
        value: 'history',
    },
]
// MaxiSafe rebranded as part of Conversant; keep only the two active
// upstream backends. Existing MaxiSafe reports in the DB map to
// `conversant` provider in the migration.
export const providerOptions = (_t: TFunction) => [
    { label: 'Mlytics', value: 'mlytics' },
    { label: 'Conversant', value: 'conversant' },
]

// Engine controls which Go generator the backend dispatches to:
//   - v1 → Mlytics + ELK pipeline (mlytics / maxisafe providers)
//   - v2 → Conversant Superset pipeline (conversant provider)
export const engineOptions = (_t: TFunction) => [
    { label: 'V1 (Mlytics + ELK)', value: 'v1' },
    { label: 'V2 (Conversant Superset)', value: 'v2' },
]

// Recommended engine per provider — UI uses this to auto-align the
// Engine dropdown when the Provider changes. Keeps the Create/Update
// form in a valid combo by default while still letting an admin
// override in the edge case where a provider + engine pair is needed.
export const engineForProvider = (
    provider: string | undefined
): 'v1' | 'v2' => {
    switch (provider) {
        case 'conversant':
            return 'v2'
        default:
            return 'v1'
    }
}
